import { render, staticRenderFns } from "./NotificationDropDown.vue?vue&type=template&id=a584b062&scoped=true"
import script from "./NotificationDropDown.vue?vue&type=script&lang=js"
export * from "./NotificationDropDown.vue?vue&type=script&lang=js"
import style0 from "./NotificationDropDown.vue?vue&type=style&index=0&id=a584b062&prod&lang=scss"
import style1 from "./NotificationDropDown.vue?vue&type=style&index=1&id=a584b062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a584b062",
  null
  
)

export default component.exports